import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'

Vue.use(require('vue-moment'));
Vue.config.productionTip = false
axios.defaults.baseURL = 'https://invapi.rhea.co.id/'

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
